// extracted by mini-css-extract-plugin
module.exports = {"h4":"made-in-india-share_h4__B5Lyw"};